import React from 'react';
import { Button, Alert, Label, Input } from 'reactstrap';
import { isValidUrl } from './utils';

const ManualUrlSection = ({
    manualUrl,
    onUrlChange,
    onSave,
    isLoading,
    isSaving,
    message,
    messageType,
}) => {
    const handleSave = () => {
        const trimmedUrl = manualUrl.trim();
        if (!isValidUrl(trimmedUrl)) {
            onSave({ error: true, message: 'Пожалуйста, введите корректный полный URL, начинающийся с http:// или https://' });
            return;
        }
        onSave({ url: trimmedUrl });
    };

    return (
        <div className="action-item mt-4 p-3 border rounded">
            <h6>Руководство пользователя</h6>
            <div className="mb-3">
                <Label for="manualUrl" className="fw-bold">Полный URL руководства</Label>
                <Input
                    type="url"
                    id="manualUrl"
                    value={manualUrl}
                    onChange={(e) => onUrlChange(e.target.value)}
                    placeholder="https://cloud.dt1520.ru/public.php/dav/files/HgRbCyqtwc7JMst"
                    disabled={isLoading || isSaving}
                    className="mb-2"
                />
                <small className="text-muted d-block mb-2">
                    Укажите полный адрес (включая http:// или https://), по которому пользователи смогут открыть руководство.
                </small>
                <div className="d-flex gap-2">
                    <Button
                        onClick={handleSave}
                        disabled={isSaving || isLoading}
                        className="dt1520-button active-dt1520-button blue-button-with-borders"
                    >
                        {isSaving ? 'Сохранение...' : 'Сохранить URL'}
                    </Button>
                </div>
                {message && (
                    <Alert color={messageType === 'success' ? 'success' : 'danger'} className="mt-3">
                        {message}
                    </Alert>
                )}
            </div>
        </div>
    );
};

export default ManualUrlSection;